import { UserRole } from '@tnf-recruit/shared'
import { useUser } from './useUser'

/**
 * Small role-switch helper shared by the profile read/edit/wizard pages.
 * Distinguishes "still loading" from "unexpected role" so neither state
 * silently falls through to the recruiter view.
 */
export function useProfileRole() {
  const { data: dbUser, isLoading } = useUser()

  return {
    role: dbUser?.role,
    isLoading,
    isStudent: dbUser?.role === UserRole.STUDENT,
    isRecruiter: dbUser?.role === UserRole.RECRUITER,
  }
}
